import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { orderService } from '../services/orderService'

export const getAllOrders = createAsyncThunk('order/getAll', async (_, { rejectWithValue }) => {
  try {
    const response = await orderService.getAll()
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const getOneOrder = createAsyncThunk('order/getOne', async (data, { rejectWithValue }) => {
  try {
    const response = await orderService.getOne(data)
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const searchOrderByTrackno = createAsyncThunk(
  'order/getOneByTrackno',
  async (data, { rejectWithValue }) => {
    try {
      const response = await orderService.searchOrderByTrackno(data)
      return response
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const changeOrderStatus = createAsyncThunk(
  'order/change-status',
  async (data, { rejectWithValue }) => {
    try {
      const response = await orderService.updateOrderStatus(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

const initialState = {
  data: [],
  singleData: {},
  loading: false,
  error: false,
  message: '',
}

const slice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    checkAll: (state) => {
      state.isChecked = !state.isChecked
    },
    resetSingleData: (state) => {
      state.singleData = {}
    },
  },
  extraReducers: {
    [getAllOrders.pending]: (state) => {
      if (state.data.length <= 0) {
        state.loading = true
      }
    },
    [getAllOrders.fulfilled]: (state, action) => {
      state.error = false
      state.data = action.payload
      state.loading = false
    },
    [getAllOrders.rejected]: (state, action) => {
      state.error = true
      state.message = action.payload
      state.loading = false
    },

    [getOneOrder.pending]: (state) => {
      state.loading = true
    },
    [getOneOrder.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [getOneOrder.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [searchOrderByTrackno.pending]: (state) => {
      state.loading = true
    },
    [searchOrderByTrackno.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [searchOrderByTrackno.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [changeOrderStatus.pending]: (state) => {
      state.loading = true
    },
    [changeOrderStatus.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [changeOrderStatus.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },
  },
})

export const { resetSingleData } = slice.actions
export default slice.reducer
